import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useTabPages } from '@ts-core/hooks/ui';

import { AssignmentAnswersPage, AssignmentExercisesPage, AssignmentResultPage } from 'modules/assignments/pages/AssignmentPageTabs';

export default function useAssignmentTabPages() {
  const intl = useIntl();

  const pages = useMemo(
    () => [
      {
        Component: AssignmentAnswersPage,

        tab: {
          label: intl.formatMessage({ id: 'assignmentDetails.tab.answers' }),
          slug: 'answers',
        },
      },
      {
        Component: AssignmentResultPage,
        tab: {
          label: intl.formatMessage({ id: 'assignmentDetails.tab.results' }),
          slug: 'results',
        },
      },
      {
        Component: AssignmentExercisesPage,
        tab: {
          label: intl.formatMessage({ id: 'assignmentDetails.tab.exercises' }),
          slug: 'exercises',
        },
      },
    ],
    [intl]
  );

  return useTabPages({ pages, slugParam: 'tab' });
}
